import {SuggestionPrimitive} from '@assistant-ui/react';
import {Icon} from '@wandb/components';
import React from 'react';

export const SUGGESTION_ITEMS = [
  {
    title: 'Summarize project',
    label: 'Summarize this project',
    prompt: 'Summarize this project',
  },
  {
    title: 'Recommend next experiment',
    label: 'Recommend my next experiment',
    prompt: 'Recommend my next experiment',
  },
  {
    title: 'Write a report',
    label: 'Write a report with visualizations for this project',
    prompt: 'Write a report with visualizations for this project',
  },
  {
    title: 'Find patterns in data',
    label: 'What patterns do you see in my results?',
    prompt: 'What patterns do you see in my results?',
  },
];

export const SuggestionItem = () => {
  return (
    <SuggestionPrimitive.Trigger
      send
      className="flex w-full min-w-0 items-center gap-2 px-4 py-2 rounded-md text-left text-sm font-semibold text-moon-600 hover:bg-moon-100 disabled:cursor-not-allowed disabled:opacity-50">
      <Icon icon="enter-switch" />
      <SuggestionPrimitive.Description className="truncate" />
    </SuggestionPrimitive.Trigger>
  );
};
